exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dl-horizontal dt[data-v-10112815] {\n  text-overflow: clip;\n  white-space: normal;\n  overflow: hidden;\n}\n@media (min-width: 768px) {\n.dl-horizontal dt[data-v-10112815] {\n    float: left;\n    width: 160px;\n    clear: left;\n    text-align: right;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n.dl-horizontal dd[data-v-10112815] {\n    margin-left: 180px;\n}\n}", ""]);

// exports
